import React, {useEffect, useRef, useState} from 'react'
import {useRouter} from 'next/router'
import {Loading} from "@/base/components/Loading";
import {MAX_MOBILE, useMediaQuery} from "@/base/utils/media.hook";

const Loader = ({expensive = false}) => (
	<div className={`fixed top-0 left-0 w-screen h-screen z-[99999999999999] flex items-center justify-center bg-black/10 ${expensive ? 'backdrop-blur-sm' : null}`}>
		<Loading show={true}/>
	</div>
);

export default function RouteLoader() {
	const router = useRouter();
	const [loading, setLoading] = useState<boolean>(false);

	const timeoutRef = useRef<any>(null);

	const isMobile = useMediaQuery(MAX_MOBILE)

	useEffect(() => {
		const handleStart = (url: string) => {
			console.debug("Start load route change", url);
			timeoutRef.current && clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => {
				setLoading(true);
			}, 500);
		};
		const handleComplete = (url: string) => {
			timeoutRef.current && clearTimeout(timeoutRef.current);
			setLoading(false);
		};

		router.events.on('routeChangeStart', handleStart);
		router.events.on('routeChangeComplete', handleComplete);
		router.events.on('routeChangeError', handleComplete);

		return () => {
			router.events.off('routeChangeStart', handleStart);
			router.events.off('routeChangeComplete', handleComplete);
			router.events.off('routeChangeError', handleComplete);
		};
	}, [router]);

	return loading ? <Loader expensive={!isMobile}/> : null;
}